import { Component } from '@angular/core';

@Component({
  selector: 'my-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent {
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts